import {
  displayFormattedNumberWithPrefixAndMultiplier,
  displayValueWithMultiplier,
  formatDerInfoSeconds
} from '../format';

import { UNIT_STRINGS } from '../appConstants';

export const DerAvailabilitySchema = {
  derId: {
    // no toDisplayString, since it will not be displayed.
  },
  readingTime: {
    // no toDisplayString, since it will not be displayed.
  },
  availabilityDuration: {
    // seconds
    powerOfTen: 2, // to compensate for the durationFormatter
    toDisplayString: formatDerInfoSeconds
  },
  maxChargeDuration: {
    // seconds
    powerOfTen: 2, // to compensate for the durationFormatter
    toDisplayString: formatDerInfoSeconds
  },
  reserveChargePercent: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  reservePercent: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  statVarAvail: {
    displayUnits: UNIT_STRINGS.REACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  statWAvail: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  }
};
